import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import styles from './Checkbox.css'

export default class Checkbox extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
  }
  static defaultProps = {
    className: null,
    checked: false,
    onChange: () => {},
    disabled: false,
  }
  constructor(props, contenxt) {
    super(props, contenxt)
    this.state = {
      checked: props.checked,
    }
  }
  componentDidMount() {
    this.element.addEventListener('change', this.handleToggle)
  }
  componentWillUnmount() {
    this.element.removeEventListener('change', this.handleToggle)
  }
  componentWillReceiveProps(nextProps) {
    if (this.state.checked !== nextProps.checked) {
      this.setState({checked: nextProps.checked})
    }
  }
  handleClick = e => {
    if (this.props.disabled) return
    this.setState({checked: !this.state.checked})
    return this.props.onChange(e)
  }
  render () {
    const {
      className,
      disabled,
    } = this.props
    const {
      checked,
    } = this.state

    return <div
      className={classnames(className, styles.element)}
      onClick={this.handleClick}
      ref={element => this.element = element}
      role='checkbox'
      aria-checked={checked}
      aria-disabled={disabled}
    />
  }
}



// WEBPACK FOOTER //
// ../src/components/Checkbox/Checkbox.js